module.exports = __webpack_public_path__ + "static/media/sv.8f52682c.png";